var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_620_23018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4802 10.7719C10.4802 11.1699 10.1542 11.49 9.74898 11.49C9.34378 11.49 9.0178 11.1699 9.0178 10.7719V2.45063L6.12354 5.29321C5.83716 5.57448 5.37408 5.57448 5.09074 5.29321C4.80741 5.01195 4.80436 4.55713 5.09074 4.27886L9.23106 0.209484C9.51744 -0.0717812 9.98052 -0.0717812 10.2639 0.209484L14.4103 4.27886C14.6966 4.56013 14.6966 5.01494 14.4103 5.29321C14.1239 5.57148 13.6608 5.57448 13.3775 5.29321L10.4832 2.45063V10.7719H10.4802ZM11.4551 10.5325V9.09628H15.5984C16.6739 9.09628 17.5483 9.95504 17.5483 11.0113V13.405C17.5483 14.4613 16.6739 15.32 15.5984 15.32H3.89953C2.82408 15.32 1.94971 14.4613 1.94971 13.405V11.0113C1.94971 9.95504 2.82408 9.09628 3.89953 9.09628H8.04289V10.5325H3.89953C3.63143 10.5325 3.41207 10.748 3.41207 11.0113V13.405C3.41207 13.6683 3.63143 13.8838 3.89953 13.8838H15.5984C15.8665 13.8838 16.0859 13.6683 16.0859 13.405V11.0113C16.0859 10.748 15.8665 10.5325 15.5984 10.5325H11.4551ZM13.6486 12.2082C13.6486 12.0177 13.7257 11.835 13.8628 11.7004C13.9999 11.5657 14.1859 11.49 14.3798 11.49C14.5737 11.49 14.7597 11.5657 14.8968 11.7004C15.0339 11.835 15.111 12.0177 15.111 12.2082C15.111 12.3986 15.0339 12.5813 14.8968 12.7159C14.7597 12.8506 14.5737 12.9263 14.3798 12.9263C14.1859 12.9263 13.9999 12.8506 13.8628 12.7159C13.7257 12.5813 13.6486 12.3986 13.6486 12.2082Z",
    fill: "#1D5AB9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_620_23018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.4982,
    height: 15.32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.543142adf39ca9cfd63b23341fdf3e6d.svg";
export { ForwardRef as ReactComponent };